<template>
  <div>
    <v-row>
      <span v-show="false">{{title}}</span>
      <v-col cols="12" md="6">
        <buy-chart :summary="true" report_type="buy"></buy-chart>
      </v-col>
      <v-col cols="12" md="6">
        <good-chart></good-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <buy-chart :summary="true" report_type="sale"></buy-chart>
      </v-col>
      <v-col cols="12" md="6">
        <profit-margin-percent-chart></profit-margin-percent-chart>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <top-good-chart report_type="buy"></top-good-chart>
      </v-col>
      <v-col cols="12" md="6">
        <top-good-chart report_type="sale"></top-good-chart>
      </v-col>
      <v-col cols="12" md="6">
        <recursive-good-chart></recursive-good-chart>
      </v-col>
      <v-col cols="12" md="6">
        <buy-and-sell-chart></buy-and-sell-chart>
      </v-col>
    </v-row>
  </div>
</template>
<script>


import BuyChart from "@/views/reports/BuyChart";
import GoodChart from "@/views/reports/GoodsChart";
import TopGoodChart from "@/views/modulePages/commerceModule/TopGoodsChart";
import BuyAndSellChart from "@/views/modulePages/commerceModule/BuyAndSellChart";
import RecursiveGoodChart from "@/views/modulePages/commerceModule/RecursiveBuyChart";
import ProfitMarginPercentChart from "@/views/modulePages/commerceModule/ProfitMarginPercentChart";
export default {
  name: "CommerceHome",
  components: {
    ProfitMarginPercentChart,
    RecursiveGoodChart,
    BuyAndSellChart,
    TopGoodChart,
    GoodChart,
    BuyChart
  },
  props: {
    id: {},
  },
  data() {
    return {
    }
  },
  computed:{
    title(){
      return this.setDocumentTitle('داشبورد بازرگانی')
    }
  }

}
</script>

<style scoped lang="scss"></style>

